import { ApolloClient, ApolloLink } from '@apollo/client';
import { RetryLink } from '@apollo/client/link/retry';
import { History } from 'history';
import { LocationErrorState } from 'Components/utils/ApiErrorFallback';
import createErrorLink from './createErrorLink';
import authLink from './authLink';
import cleanParamsLink from './cleanParamsLink';
import devWorkbenchSeedLink from './devWorkbenchSeedLink';
import httpLink from './httpLink';
import createInMemoryCache from './cache';

// 4xx = client error; the same payload will always fail the same way, so retrying
// it just adds noise. 5xx and no-response (undefined statusCode) are transient
// and worth retrying.
export const retryLink = new RetryLink({
  attempts: { retryIf: error => !error?.statusCode || error.statusCode >= 500 },
});

const createApolloClient = (history: History<LocationErrorState>) =>
  new ApolloClient({
    link: ApolloLink.from(
      [
        // Dev-only fixture injector. Tree-shaken out of production builds (the module exports
        // `null` when NODE_ENV !== 'development') and inert at runtime unless the
        // `?__devWorkbenchFixture=1` URL flag is present.
        devWorkbenchSeedLink,
        cleanParamsLink,
        createErrorLink(history),
        retryLink,
        authLink,
        httpLink,
      ].filter((link): link is ApolloLink => link !== null),
    ),
    cache: createInMemoryCache(),
  });

export default createApolloClient;
